import { render, staticRenderFns } from "./createMailingListModal.vue?vue&type=template&id=b5811a94"
import script from "./createMailingListModal.vue?vue&type=script&lang=js"
export * from "./createMailingListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports